import React, { useState, useEffect, useRef } from "react";
import NextButton from "../Component/NextButton";
import BackButton from "../Component/BackButton";
import { Undo2, Mic, Square, Volume2 } from "lucide-react";
import CartChatpterComp from "./CartChatpterComp";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";

function Answer_question({ answer_question, picture }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState({});
  const [results, setResults] = useState({});
  const [isWaiting, setIsWaiting] = useState(false);
  const [value, setValue] = useState(false);
  const [userAnswerQuestion, setUserAnswerQuestion] = useState([]);
  const [userText, setUserText] = useState("");
  const [status, setStatus] = useState(false);
  const [tab, setTab] = useState(0);
  const [listeningState, setListeningState] = useState("idle"); // idle, recording, analyzing, success, error
  const currentItem = answer_question[currentIndex];

  const [userAllContent, setUserAllContent] = useState({
    userId: "",
    name: "",
    class_name: "",
    answer_question: null,
  });

  const contentValue = useSelector((state) => state.extra.value);
  const user = JSON.parse(localStorage.getItem("postUser"));
  const navigate = useNavigate();
  useEffect(() => {
    if (currentIndex === answer_question.length) {
      setUserAllContent({
        class_name: contentValue.class_name,
        name: contentValue.name,
        answer_question: userAnswerQuestion,
        userId: user._id,
      });
      setValue(true);
      setTab(3);
    }
  }, [currentIndex, answer_question.length]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (
        mediaRecorderRef.current &&
        mediaRecorderRef.current.state === "recording"
      ) {
        mediaRecorderRef.current.stop();
      }
    };
  }, []);

  // Soruyu Seslendir
  const askQuestion = (text) => {
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    utterance.rate = 0.8;
    window.speechSynthesis.speak(utterance);
  };

  // --- WHISPER / BACKEND ENTEGRASYONU ---
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef(null);
  const timeoutRef = useRef(null);

  const startListening = async () => {
    try {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (e) => {
        if (e.data.size > 0) audioChunksRef.current.push(e.data);
      };

      mediaRecorderRef.current.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, {
          type: "audio/webm",
        });
        await sendAudioToBackend(audioBlob);
        stream.getTracks().forEach((track) => track.stop());
      };

      setListeningState("recording");
      setUserText("");
      setStatus(null);

      mediaRecorderRef.current.start();

      timeoutRef.current = setTimeout(() => {
        if (
          mediaRecorderRef.current &&
          mediaRecorderRef.current.state === "recording"
        ) {
          stopListening();
        }
      }, 3500);
    } catch (err) {
      console.error("Microphone access error:", err);
      setListeningState("error");
      setUserText("Microphone access denied.");
      setTimeout(() => setListeningState("idle"), 2000);
    }
  };

  const stopListening = () => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state === "recording"
    ) {
      mediaRecorderRef.current.stop();
      setListeningState("analyzing");
      setUserText("Analyzing your answer...");
    }
  };

  const sendAudioToBackend = async (blob) => {
    const formData = new FormData();
    formData.append("audio", blob, "vocal.webm");

    try {
      //  setTranscript("Analyzing...");

      const response = await api.post("/transcribe", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.success) {
        const transcript = response.data.transcript.toLowerCase().trim();

        const isCorrect = currentItem.answers.some(
          (ans) =>
            transcript.includes(ans.toLowerCase().trim()) ||
            ans.toLowerCase().trim().includes(transcript),
        );

        setUserAnswers((prev) => ({ ...prev, [currentIndex]: transcript }));
        setStatus(isCorrect);
        setResults((prev) => ({
          ...prev,
          [currentIndex]: isCorrect ? "correct" : "wrong",
        }));
        setListeningState(isCorrect ? "success" : "error");

        if (isCorrect) {
          setUserText(`✓ Correct! "${transcript}"`);
        } else {
          setUserText(`✗ Try again! "${transcript}"`);
        }

        setUserAnswerQuestion((prev) => [
          ...prev,
          {
            answerId: currentItem._id,
            givenAnswer: transcript,
            answers: currentItem.answers,
            question: currentItem.question,
            status: isCorrect,
          },
        ]);

        setIsWaiting(true);
        setTimeout(() => {
          setCurrentIndex((prev) => prev + 1);
          setIsWaiting(false);
          setListeningState("idle");
          setUserText("");
        }, 2500);
      } else {
        setListeningState("error");
        setUserText("Could not understand, try again.");
        setTimeout(() => setListeningState("idle"), 2000);
      }
    } catch (error) {
      console.error("Whisper Backend Error:", error);
      setListeningState("error");
      setUserText("Connection error.");
      setTimeout(() => setListeningState("idle"), 2000);
    }
  };

  const handleNextButton = () => {
    if (currentIndex < answer_question.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setListeningState("idle");
      setUserText("");
    }
  };

  const handleBackButton = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      setListeningState("idle");
      setUserText("");
    }
  };

  // useEffect(() => {
  //   if (currentIndex === answer_question.length) {
  //     setUserAllContent({
  //       class_name: contentValue.class_name,
  //       name: contentValue.name,
  //       answer_question: userAnswerQuestion,
  //       userId: user._id,
  //     });
  //     setValue(true);
  //     setTab(3);
  //   }
  // }, [currentIndex, answer_question.length]);

  // useEffect(() => {
  //   return () => {
  //     if (timeoutRef.current) clearTimeout(timeoutRef.current);
  //     if (
  //       mediaRecorderRef.current &&
  //       mediaRecorderRef.current.state === "recording"
  //     ) {
  //       mediaRecorderRef.current.stop();
  //     }
  //   };
  // }, []);

  if (tab === 3) {
    return (
      <CartChatpterComp
        value={value}
        status="answer_question"
        userAllContent={userAllContent}
      />
    );
  }

  if (currentIndex >= answer_question.length) {
    return null;
  }

  const isRecordingOrAnalyzing =
    listeningState === "recording" || listeningState === "analyzing";

  // Duruma göre Speak butonu ve Orta panelin stil şeması
  const getDynamicConfig = () => {
    switch (listeningState) {
      case "recording":
        return {
          centerStyle: "bg-red-500 border-red-600 text-white animate-pulse",
          centerText: "🎙️ Recording... Speak now!",
          centerSub: "YOUR SPEECH IS BEING RECORDED",
          speakBtnColor: "bg-red-600 border-red-700 shadow-[0_4px_0_#991b1b]",
        };
      case "analyzing":
        return {
          centerStyle: "bg-purple-600 border-yellow-700 text-white",
          centerText: "🤔 Analyzing your answer...",
          centerSub: "WHISPER AI IS CHECKING",
          speakBtnColor:
            "bg-purple-700 border-purple-800 shadow-[0_4px_0_#4c1d95]",
        };
      case "success":
        return {
          centerStyle: "bg-green-500 border-green-600 text-white font-black",
          centerText: userText || "✓ Excellent! ⭐",
          centerSub: "RESULT: CORRECT",
          speakBtnColor:
            "bg-green-600 border-green-700 shadow-[0_4px_0_#15803d]",
        };
      case "error":
        return {
          centerStyle: "bg-red-500 border-red-600 text-white font-bold",
          centerText: userText || "❌ Try Again! 💪",
          centerSub: "RESULT: WRONG / NOT UNDERSTOOD",
          speakBtnColor: "bg-red-600 border-red-700 shadow-[0_4px_0_#991b1b]",
        };
      default:
        return {
          centerStyle: "bg-white border-yellow-500 text-purple-950",
          centerText: currentItem.question,
          centerSub: "QUESTION",
          speakBtnColor:
            "bg-purple-600 hover:bg-purple-700 border-purple-700 active:translate-y-[2px] active:shadow-[0_2px_0_#5b21b6] shadow-[0_4px_0_#5b21b6]",
        };
    }
  };

  const dynamicConfig = getDynamicConfig();

  return (
    <div
      className="flex flex-col w-full gap-4 max-w-5xl mx-auto rounded-xl  overflow-hidden"
      style={{ fontFamily: "Inter, system-ui, -apple-system, sans-serif" }}
    >
      <div className="grid grid-cols-4 p-2 items-center w-full gap-4 bg-yellow-500 rounded-xl">
        <div className="col-span-3 md:col-span-3 flex items-center">
          <span className="font-medium rounded-xl text-white text-md p-2">
            Answer Question
          </span>
        </div>
        <div className="col-span-1 md:col-span-1 flex justify-end items-center">
          <button
            onClick={() => navigate("/extraPage")}
            className="bg-gray-100 h-10 w-10 text-red-500 hover:bg-red-500
             hover:text-gray-100 transition-all rounded-full
             flex items-center justify-center shadow-lg active:scale-90 shrink-0"
          >
            <Undo2 size={20} />
          </button>
        </div>
      </div>
      <div
        className="flex flex-col w-full bg-purple-500 gap-4 max-w-5xl 
      mx-auto rounded-xl shadow-2xl overflow-hidden"
      >
        <div className="grid grid-cols-12 p-2 justify-center items-center w-full gap-2 md:gap-4">
          {/* Geri Butonu */}
          <div
            className={`col-span-2 sm:col-span-1 flex justify-start items-center ${
              currentIndex === 0 || isRecordingOrAnalyzing
                ? "opacity-30 pointer-events-none"
                : ""
            }`}
          >
            <BackButton handleBackButton={handleBackButton} />
          </div>
          {/* ÜST KISIM: Başlık ve İlerleme Noktaları */}
          <div className="col-span-8 sm:col-span-10 flex justify-center items-center">
            <div className="flex flex-wrap justify-center items-center gap-2 p-2 rounded-2xl">
              {answer_question.map((_, i) => (
                <div
                  key={i}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    i === currentIndex
                      ? "bg-yellow-400 scale-150 shadow-md"
                      : results[i] === "correct"
                        ? "bg-green-400"
                        : results[i] === "wrong"
                          ? "bg-red-400"
                          : "bg-purple-300"
                  }`}
                />
              ))}
            </div>
          </div>
          {/* İleri Butonu */}
          <div
            className={`col-span-2 sm:col-span-1 flex justify-end items-center ${
              currentIndex === answer_question.length - 1 ||
              isRecordingOrAnalyzing
                ? "opacity-30 pointer-events-none"
                : ""
            }`}
          >
            <NextButton handleNextButton={handleNextButton} />
          </div>
        </div>
        {/* ORTA KISIM: Resim ve Yan Butonlar */}
        <div className="flex flex-row items-center justify-between gap-4 ">
          <div className="flex-1 flex flex-col items-center gap-4">
            <div className="w-full max-w-2xl rounded-2xl shadow-inner relative border-l-6 border-yellow-500">
              <img
                src={picture}
                alt="Exercise"
                className="w-full h-full rounded-xl aspect-video "
              />
            </div>

            {/* bilgisayar ve tablet için */}
            <div
              className="w-full max-w-2xl  lg:grid grid-cols-12 rounded-xl p-4 gap-3 items-stretch 
             min-h-[140px] hidden "
            >
              {/* 🔊 1. SÜTUN: LISTEN (DİNLEME) BUTONU (SOLDA) */}
              <button
                disabled={isRecordingOrAnalyzing}
                onClick={() => askQuestion(currentItem.question)}
                className="col-span-3 flex flex-col justify-center items-center gap-1 rounded-xl py-5
               bg-yellow-500 hover:bg-yellow-400 text-white transition-all duration-150
                h-full cursor-pointer select-none disabled:opacity-40 disabled:pointer-events-none"
              >
                <Volume2 size={28} />
                <span className="text-xs font-black uppercase tracking-wider mt-1">
                  Listen
                </span>
              </button>

              {/* 🧠 2. SÜTUN: BİRLEŞİK AKILLI ORTA PANEL (DURUMSAL EKRAN) */}
              <div
                className={`col-span-6  p-3 rounded-xl flex items-center justify-start 
                text-left transition-all duration-300 shadow-inner border-l-6 border-yellow-500 h-full overflow-hidden  ${dynamicConfig.centerStyle}`}
              >
                <div className="flex items-center gap-3 w-full">
                  {/* Sadece normal durumda veya başarı durumunda emoji gösterilsin */}
                  {listeningState === "idle" || listeningState === "success"}
                  <div className="flex flex-col w-full min-w-0">
                    <span className="text-[8px] font-bold uppercase tracking-widest opacity-60 block mb-0.5">
                      {dynamicConfig.centerSub}
                    </span>
                    <h2 className="text-xs md:text-sm font-black leading-tight line-clamp-3">
                      {dynamicConfig.centerText}
                    </h2>
                  </div>
                </div>
              </div>

              {/* 🎙️ 3. SÜTUN: SPEAK (MİKROFON) BUTONU (SAĞDA) */}
              <button
                disabled={isRecordingOrAnalyzing || isWaiting}
                onClick={startListening}
                className={`col-span-3 flex flex-col justify-center items-center gap-1 rounded-xl py-5
               bg-yellow-500 hover:bg-yellow-400 text-white transition-all duration-150
                h-full cursor-pointer select-none disabled:opacity-40 disabled:pointer-events-none `}
              >
                {listeningState === "recording" ? (
                  <Square size={26} className="animate-pulse" />
                ) : listeningState === "analyzing" ? (
                  <div className="w-6 h-6 border-3 border-white border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  <Mic size={28} />
                )}
                <span className="text-xs font-black uppercase tracking-wider mt-1">
                  {listeningState === "recording" ? "Stop" : "Speak"}
                </span>
              </button>
            </div>

            {/* telefon için */}
            <div className="w-full max-w-2xl  grid grid-rows-2 rounded-xl p-4 gap-3 items-stretch min-h-[140px] lg:hidden">
              {/* 🧠 2. SÜTUN: BİRLEŞİK AKILLI ORTA PANEL (DURUMSAL EKRAN) */}
              <div
                className={`row-span-1 p-3 rounded-xl flex items-center justify-start 
                text-left transition-all duration-300 shadow-inner border-l-6 border-yellow-500 h-full overflow-hidden  ${dynamicConfig.centerStyle}`}
              >
                <div className="flex items-center gap-3 w-full">
                  {/* Sadece normal durumda veya başarı durumunda emoji gösterilsin */}
                  {listeningState === "idle" || listeningState === "success"}
                  <div className="flex flex-col w-full min-w-0">
                    <span className="text-[8px] font-bold uppercase tracking-widest opacity-60 block mb-0.5">
                      {dynamicConfig.centerSub}
                    </span>
                    <h2 className="text-xs md:text-sm font-black leading-tight line-clamp-3">
                      {dynamicConfig.centerText}
                    </h2>
                  </div>
                </div>
              </div>

              <div className="row-span-1 flex justify-between items-center gap-2">
                {/* 🔊 1. SÜTUN: LISTEN (DİNLEME) BUTONU (SOLDA) */}

                <button
                  disabled={isRecordingOrAnalyzing}
                  onClick={() => askQuestion(currentItem.question)}
                  className=" flex flex-col justify-center w-full items-center gap-1 rounded-xl py-5
               bg-yellow-500 hover:bg-yellow-400 text-white transition-all duration-150
                h-full cursor-pointer select-none disabled:opacity-40 disabled:pointer-events-none"
                >
                  <Volume2 size={28} />
                  <span className="text-xs font-black uppercase tracking-wider mt-1">
                    Listen
                  </span>
                </button>

                {/* 🎙️ 3. SÜTUN: SPEAK (MİKROFON) BUTONU (SAĞDA) */}
                <button
                  disabled={isRecordingOrAnalyzing || isWaiting}
                  onClick={startListening}
                  className={`w-full flex flex-col justify-center items-center gap-1 rounded-xl py-5
               bg-yellow-500 hover:bg-yellow-400 text-white transition-all duration-150
                h-full cursor-pointer select-none disabled:opacity-40 disabled:pointer-events-none `}
                >
                  {listeningState === "recording" ? (
                    <Square size={26} className="animate-pulse" />
                  ) : listeningState === "analyzing" ? (
                    <div className="w-6 h-6 border-3 border-white border-t-transparent rounded-full animate-spin"></div>
                  ) : (
                    <Mic size={28} />
                  )}
                  <span className="text-xs font-black uppercase tracking-wider mt-1">
                    {listeningState === "recording" ? "Stop" : "Speak"}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Answer_question;
